// YERİ: src/app/domains/site/sections/cta.section.ts
// Aksiyon çağrısı bandı (accent arka plan).

import { inject, Component, computed, input } from '@angular/core';
import { SiteConfig, cfg } from './section.model';
import { SiteChromeText } from '../core/site-chrome-text';

@Component({
  selector: 'sec-cta',
  standalone: true,
  template: `
    <section id="cta" class="py-20" style="background-color:var(--site-accent)">
      <div class="mx-auto max-w-4xl px-6 text-center lg:px-8">
        <h2 class="font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-white sm:text-4xl">{{ title() }}</h2>
        @if (subtext()) { <p class="mx-auto mt-4 max-w-2xl text-lg text-white/85">{{ subtext() }}</p> }
        <a [href]="ctaUrl()" [target]="newTab() ? '_blank' : '_self'" [attr.rel]="newTab() ? 'noopener' : null"
           class="ws-btn mt-9 inline-flex items-center justify-center rounded-lg bg-white px-8 py-3.5 text-sm font-semibold shadow-lg transition hover:opacity-90"
           style="color:var(--site-primary)">
          {{ ctaText() }}
        </a>
      </div>
    </section>
  `,
})
export class CtaSection {
  protected text = inject(SiteChromeText);
  config = input<SiteConfig>({});
  protected title = computed(() => cfg(this.config(), 'title', this.text.t('fb.hukukiSorununuzIcinHemen')));
  protected subtext = computed(() => cfg(this.config(), 'subtext', this.text.t('fb.ilkDegerlendirmeGorusmesiUcretsizdir')));
  protected ctaText = computed(() => cfg(this.config(), 'ctaText', this.text.t('sd.randevuAl')));
  protected ctaUrl = computed(() => cfg(this.config(), 'ctaUrl', '#contact'));
  protected newTab = computed(() => ['true', 'evet', '1'].includes(String(cfg(this.config(), 'ctaNewTab', '')).toLowerCase()));
}
